import { Menu } from "@mui/material";
import React from "react";
import usePermissions from "../../permissions/usePermissions";
import { NavigationEntry, NavigationEntryItem } from "../Navigation";
import NavigationMenuItem from "./NavigationMenuItem";

export type NavigationItemMenuProps = {
    onCloseMenu?: () => void;
    onOptionClick?: () => void;
    anchorEl: null | HTMLElement;
    items: Array<NavigationEntry>;
};

const CollapsedItemsMenu = ({ onCloseMenu, anchorEl, onOptionClick, items }: NavigationItemMenuProps) => {
    const { hasAtLeastOnePermissionOrEmpty } = usePermissions();
    const optimisedEntries: Array<NavigationEntry> = React.useMemo(() => {
        const optimisedEntries: Array<NavigationEntry> = [];
        for (let i = 0; i < items.length; i++) {
            const entry = items[i];
            const entryIsDivider = entry.divider === true;
            const lastItemIsDivider = optimisedEntries.length === 0 || optimisedEntries[optimisedEntries.length - 1].divider === true;
            const hasPermissionOnEntry = entryIsDivider ? true : hasAtLeastOnePermissionOrEmpty(entry.permissionsAtLeastOne);

            const isUniqueDivider = entryIsDivider && !lastItemIsDivider;
            const isAuthorizedEntry = !entryIsDivider && hasPermissionOnEntry;
            if (isUniqueDivider || isAuthorizedEntry) {
                optimisedEntries.push(entry);
            }
        }
        if (optimisedEntries.length > 0 && optimisedEntries[optimisedEntries.length - 1]?.divider === true) {
            optimisedEntries.pop();
        }
        return optimisedEntries;
    }, [hasAtLeastOnePermissionOrEmpty, items]);

    return (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
                vertical: "top",
                horizontal: "right",
            }}
            open={Boolean(anchorEl)}
            onClose={onCloseMenu}
        >
            {optimisedEntries.map((item, index) => (
                <NavigationMenuItem key={(item as NavigationEntryItem)?.link ?? index} item={item} onOptionClick={onOptionClick} />
            ))}
        </Menu>
    );
};

export default CollapsedItemsMenu;
